compiler(".top-spacer", function(element) {
  const navbar = document.querySelector(".navbar")
  const globalAnnouncement = document.querySelector("#global-announcement")

  function setHeight() {
    let elements = [navbar]
    if (globalAnnouncement) { elements.push(globalAnnouncement) }
    const combinedHeight = getCombinedHeight(elements)
    element.style.height = combinedHeight + "px"
  }

  function getCombinedHeight(elements) {
    let combinedHeight = 0
    elements.forEach(element => {
      combinedHeight += element.getBoundingClientRect().height
    })
    return combinedHeight
  }

  const resizeObserver = new ResizeObserver(() => {
    setHeight()
  })

  resizeObserver.observe(navbar)

  setHeight()

  return () => {
    resizeObserver.unobserve(navbar)
    resizeObserver.disconnect()
  }
})
